import wifi from "../../images/services_room/wifi.svg";
import bedding from "../../images/services_room/BH Icons 30 p_Bedding.svg";
import kingbed from "../../images/services_room/king size bedroom.svg";
import sharedlink from "../../images/services_room/share icon.svg";
import cereal from "../../images/services_room/cereal.svg";
import selfcheckin from "../../images/services_room/BH Icons 30 p_Check-In.svg";
import freeparking from "../../images/services_room/BH Icons 30 p_Parking.svg";
import selfbreakfast from "../../images/services_room/BH Icons 30 p_Breakfast.svg";
import kitchenfacilities from "../../images/services_room/BH Icons 30 p_Cutlery.svg";
import ironingfacilities from "../../images/services_room/BH Icons 30 p_Ironing.svg";
import gardenview from "../../images/services_room/garden.svg";
import seaview from "../../images/services_room/BH Icons 30 p_Sea View.svg";
import tv from "../../images/services_room/tv.svg";
import peoples from "../../images/services_room/guests.svg";
import sharedbathroom from "../../images/services_room/shared bathroom.svg";
import selfservicebreakfast from "../../images/services_room/self service breakfast.svg";
import budgetfriendly from "../../images/services_room/Vertical container.svg";
import info from "../../images/services_room/info.svg";
import spot from "../../images/services_room/spot.svg";
import busstop from "../../images/services_room/bus.svg";
import car from "../../images/services_room/car.svg";
import airport from "../../images/services_room/airplane.svg";
import privatebathroom from "../../images/services_room/private bathroom.svg";
import privatedinning from "../../images/services_room/private dining.svg";
import kitchen from "../../images/services_room/kitchen.svg";
import uptoseex from "../../images/services_room/up_to_6.svg";
// import main01 from "../../images/services_room/card room house__image01.webp";
// import main02 from "../../images/services_room/card room house__image02.webp";
// import main03 from "../../images/services_room/card room house__image03.webp";
// import main04 from "../../images/services_room/card room house__image04.webp";
// import main05 from "../../images/services_room/card room house__image05.webp";
// import main06 from "../../images/services_room/card room house__image06.webp";
// import main07 from "../../images/services_room/card room house__image07.webp";

import ecdr01 from "../../images/services_room/Economy_Double_Room/01.webp";
import ecdr02 from "../../images/services_room/Economy_Double_Room/02.webp";

import dtr01 from "../../images/services_room/Double_Twin_Room/01.webp";
import dtr02 from "../../images/services_room/Double_Twin_Room/02.webp";
import dtr03 from "../../images/services_room/Double_Twin_Room/03.webp";
import dtr04 from "../../images/services_room/Double_Twin_Room/04.webp";
import dtr05 from "../../images/services_room/Double_Twin_Room/05.webp";

// import tr01 from "../../images/services_room/Triple_Room/01.webp";
// import tr02 from "../../images/services_room/Triple_Room/02.webp";
import tr03 from "../../images/services_room/Triple_Room/03.webp";
import tr04 from "../../images/services_room/Triple_Room/04.webp";
import tr05 from "../../images/services_room/Triple_Room/05.webp";

// import qr01 from "../../images/services_room/Quadruple_Room/01.webp";
// import qr02 from "../../images/services_room/Quadruple_Room/02.webp";
import qr03 from "../../images/services_room/Quadruple_Room/03.webp";
import qr04 from "../../images/services_room/Quadruple_Room/04.webp";
import qr05 from "../../images/services_room/Quadruple_Room/05.webp";

import fr01 from "../../images/services_room/Family_Room/01.webp";
// import fr02 from "../../images/services_room/Family_Room/02.webp";
import fr03 from "../../images/services_room/Family_Room/03.webp";
import fr04 from "../../images/services_room/Family_Room/04.webp";
import fr05 from "../../images/services_room/Family_Room/05.webp";
import fr06 from "../../images/services_room/Family_Room/06.webp";
import fr07 from "../../images/services_room/Family_Room/07.webp";
import fr08 from "../../images/services_room/Family_Room/08.webp";

import tba01 from "../../images/services_room/Two_Bedroom_Apartment/01.webp";
import tba02 from "../../images/services_room/Two_Bedroom_Apartment/02.webp";
import tba03 from "../../images/services_room/Two_Bedroom_Apartment/03.webp";
import tba04 from "../../images/services_room/Two_Bedroom_Apartment/04.webp";
import tba05 from "../../images/services_room/Two_Bedroom_Apartment/05.webp";
import tba06 from "../../images/services_room/Two_Bedroom_Apartment/06.webp";
import tba07 from "../../images/services_room/Two_Bedroom_Apartment/07.webp";
import tba08 from "../../images/services_room/Two_Bedroom_Apartment/08.webp";
import tba09 from "../../images/services_room/Two_Bedroom_Apartment/09.webp";
import tba10 from "../../images/services_room/Two_Bedroom_Apartment/010.webp";
import tba11 from "../../images/services_room/Two_Bedroom_Apartment/011.webp";
import tba12 from "../../images/services_room/Two_Bedroom_Apartment/012.webp";
import tba13 from "../../images/services_room/Two_Bedroom_Apartment/013.webp";
import tba14 from "../../images/services_room/Two_Bedroom_Apartment/014.webp";
import tba15 from "../../images/services_room/Two_Bedroom_Apartment/015.webp";
import tba16 from "../../images/services_room/Two_Bedroom_Apartment/016.webp";
import tba17 from "../../images/services_room/Two_Bedroom_Apartment/017.webp";

import trba01 from "../../images/services_room/Three_Bedroom_Apartment/01.webp";
import trba02 from "../../images/services_room/Three_Bedroom_Apartment/02.webp";
import trba03 from "../../images/services_room/Three_Bedroom_Apartment/03.webp";
import trba04 from "../../images/services_room/Three_Bedroom_Apartment/04.webp";
import trba05 from "../../images/services_room/Three_Bedroom_Apartment/05.webp";
import trba06 from "../../images/services_room/Three_Bedroom_Apartment/06.webp";
import trba07 from "../../images/services_room/Three_Bedroom_Apartment/07.webp";
import trba08 from "../../images/services_room/Three_Bedroom_Apartment/08.webp";
import trba09 from "../../images/services_room/Three_Bedroom_Apartment/09.webp";

const BASE_URL = `${window.location.protocol}//${window.location.host}`;

export const price = [
  {
    name: "Economy Double Room",
    type1: "Non-refundable",
    price1: "80.00",
    type2: "Refundable",
    price2: "90.00",
    icon: info,
  },
  {
    name: "Double/Twin Room",
    type1: "Non-refundable",
    price1: "85.92",
    type2: "Refundable",
    price2: "95.92",
    icon: info,
  },
  {
    name: "Triple Room",
    type1: "Non-refundable",
    price1: "108.56",
    type2: "Refundable",
    price2: "118.56",
    icon: info,
  },
  {
    name: "Quadruple Room",
    type1: "Non-refundable",
    price1: "127.68",
    type2: "Refundable",
    price2: "137.68",
    icon: info,
  },
  {
    name: "Family Room",
    type1: "Non-refundable",
    price1: "127.68",
    type2: "Refundable",
    price2: "137.68",
    icon: info,
  },
  {
    name: "Two Bedroom Apartment",
    type1: "Non-refundable",
    price1: "127.68",
    type2: "Refundable",
    price2: "137.68",
    icon: info,
  },
  {
    name: "Three Bedroom Apartment",
    type1: "Non-refundable",
    price1: "127.68",
    type2: "Refundable",
    price2: "137.68",
    icon: info,
  },
];

export const achievements = [
  {
    name: "Popular Spot for Northern Lights",
    icon: spot,
  },
  {
    name: "4 Min Walk to Bus Stop",
    icon: busstop,
  },
  {
    name: "10 Min Drive from Town",
    icon: car,
  },
  {
    name: "55 Min Drive from Airport",
    icon: airport,
  },
  {
    name: "Late Night Self Check In",
    icon: airport,
  },
];

export const items = [
  {
    title: "Economy Double Room",
    photos: [ecdr02, ecdr01],
    type: "room",
    links: {
      icon: sharedlink,
      href: `${BASE_URL}/beds24/economy_double_room`,
    },
    // mainImage: main01,
    mainImage: ecdr02,
    services: [
      {
        name: "Best for 2 people",
        icon: peoples,
      },
      {
        name: "Queen sized bed",
        icon: kingbed,
      },
      {
        name: "Shared bathroom",
        icon: sharedbathroom,
      },
      {
        name: "Self service breakfast",
        icon: selfservicebreakfast,
      },
      {
        name: "Budget friendly",
        icon: budgetfriendly,
      },
      {
        name: "Free Fast WiFi",
        icon: wifi,
      },
      {
        name: "Netflix TV",
        icon: tv,
      },
    ],
    description:
      "Our economy double rooms are located at 3 of our properties. Facing Valhúsahaedpark, the rooms are equipped with a queen-size bed and Netflix TV. All offer shared bathroom and kitchenfacilities. Continental self-service breakfast with homemade bread is included in the room rate. House andtype of bed can not be guaranteed.",
    amenities: [
      {
        name: "Queen sized bed",
        icon: kingbed,
      },
      {
        name: "Bedding provided",
        icon: bedding,
      },
      {
        name: "Shared bathroom",
        icon: sharedbathroom,
      },
      {
        name: "Self check-in anytime",
        icon: selfcheckin,
      },
      {
        name: "Free parking",
        icon: freeparking,
      },
      {
        name: "Self service continental breakfast",
        icon: selfbreakfast,
      },
      {
        name: "Kitchen facilities",
        icon: kitchenfacilities,
      },
      {
        name: "Ironing facilities",
        icon: ironingfacilities,
      },
      {
        name: "Garden view",
        icon: gardenview,
      },
      {
        name: "Sea view",
        icon: seaview,
      },
      {
        name: "Television with Netflix",
        icon: tv,
      },
    ],
    price: [
      {
        nameOne: "Non-refundable:",
        valueOne: "124.48",
        nameTwo: "Refundable:",
        valueTwo: "134.48",
        icon: info,
      },
    ],
  },
  //Double/Twin Room
  {
    type: "room",
    photos: [dtr03, dtr01, dtr02, dtr04, dtr05],
    title: "Double/Twin Room",
    links: {
      icon: sharedlink,
      href: `${BASE_URL}/beds24/double_twin_room`,
    },
    // mainImage: main02,
    mainImage: dtr03,
    services: [
      {
        name: "Best for 2 people",
        icon: peoples,
      },
      {
        name: "King/Twin Sized Bed",
        icon: kingbed,
      },
      {
        name: "Shared bathroom",
        icon: sharedbathroom,
      },
      {
        name: "Self service breakfast",
        icon: selfservicebreakfast,
      },
      {
        name: "Budget friendly",
        icon: budgetfriendly,
      },
      {
        name: "Seaside view",
        icon: seaview,
      },
      {
        name: "Netflix TV",
        icon: tv,
      },
      {
        name: "Free Fast WiFi",
        icon: wifi,
      },
    ],
    description:
      "Our double/twin rooms are located at 3 of our properties. Facing the seaside, the rooms areequipped with a king-size or twin bed and Netflix TV. All offer shared bathroom and kitchen facilities. Continentalself-service breakfast with homemade bread is included in the room rate. House and type of bed can not beguaranteed.",
    amenities: [
      {
        name: "Queen sized bed",
        icon: kingbed,
      },
      {
        name: "Shared bathroom",
        icon: sharedbathroom,
      },
      {
        name: "Self service continental breakfast",
        icon: selfbreakfast,
      },
      {
        name: "Television with Netflix",
        icon: tv,
      },
      {
        name: "Bedding provided",
        icon: bedding,
      },
      {
        name: "Kitchen facilities",
        icon: kitchenfacilities,
      },
      {
        name: "Self check-in anytime",
        icon: selfcheckin,
      },
      {
        name: "Free parking",
        icon: freeparking,
      },
    ],
    price: [
      {
        nameOne: "Non-refundable:",
        valueOne: "124.48",
        nameTwo: "Refundable:",
        valueTwo: "134.48",
        icon: info,
      },
    ],
  },
  //Triple Room
  {
    title: "Triple Room",
    photos: [tr03, tr04, tr05],
    type: "room",
    links: {
      icon: sharedlink,
      href: `${BASE_URL}/beds24/triple_room`,
    },
    // mainImage: main03,
    mainImage: tr03,
    services: [
      {
        name: "Best for 3 people",
        icon: peoples,
      },
      {
        name: "Queen/Twin Beds",
        icon: kingbed,
      },
      {
        name: "Shared bathroom",
        icon: sharedbathroom,
      },
      {
        name: "Self service breakfast",
        icon: selfservicebreakfast,
      },
      {
        name: "Budget friendly",
        icon: budgetfriendly,
      },
      {
        name: "Netflix TV",
        icon: tv,
      },
      {
        name: "Free Fast WiFi",
        icon: wifi,
      },
    ],
    description:
      "Our triple rooms are located both in the Blue House and the Yellow House. The rooms areequipped with a king-size/twin bed and Netflix-TV. Extra beds are queensized sofabeds. Bathroom and kitchenfacilities are shared. Continental self-service breakfast with homemade bread is included.",
    amenities: [
      {
        name: "Queen sized bed",
        icon: kingbed,
      },
      {
        name: "Shared bathroom",
        icon: sharedbathroom,
      },
      {
        name: "Self service continental breakfast",
        icon: selfbreakfast,
      },
      {
        name: "Television with Netflix",
        icon: tv,
      },
      {
        name: "Bedding provided",
        icon: bedding,
      },
      {
        name: "Kitchen facilities",
        icon: kitchenfacilities,
      },
      {
        name: "Self check-in anytime",
        icon: selfcheckin,
      },
      {
        name: "Free parking",
        icon: freeparking,
      },
    ],
    price: [
      {
        nameOne: "Non-refundable:",
        valueOne: "124.48",
        nameTwo: "Refundable:",
        valueTwo: "134.48",
        icon: info,
      },
    ],
  },
  //Quadruple Room
  {
    type: "room",
    photos: [qr03, qr04, qr05],
    title: "Quadruple Room",
    links: {
      icon: sharedlink,
      href: `${BASE_URL}/beds24/Quadruple_room`,
    },
    // mainImage: main04,
    mainImage: qr03,
    services: [
      {
        name: "King Sized Bed + Sofa Bed",
        icon: kingbed,
      },
      {
        name: "Shared bathroom",
        icon: sharedbathroom,
      },
      {
        name: "Cereal breakfast",
        icon: cereal,
      },
      {
        name: "Budget friendly",
        icon: budgetfriendly,
      },
      {
        name: "Netflix TV",
        icon: tv,
      },
      {
        name: "Free Fast WiFi",
        icon: wifi,
      },
    ],
    description:
      "Our quadruple rooms are located both in the Blue House and the Yellow House. Therooms are equipped with a king-size/twin bed and Netflix-TV. Extra beds are queensized sofabeds. Bathroom andkitchen facilities are shared. Quadruple room with private bathroom and living room can be booked at surcharge uponavailability. Cereal Breakfast at the apartment is included in the rate. Continental self-service breakfast with homemadebread can be booked at surcharge.",
    amenities: [
      {
        name: "King size bed + Sofa bed",
        icon: kingbed,
      },
      {
        name: "Shared bathroom",
        icon: sharedbathroom,
      },
      {
        name: "Self service continental breakfast",
        icon: selfbreakfast,
      },
      {
        name: "Television with Netflix",
        icon: tv,
      },
      {
        name: "Bedding provided",
        icon: bedding,
      },
      {
        name: "Cereal breakfast included",
        icon: cereal,
      },
      {
        name: "Self check-in anytime",
        icon: selfcheckin,
      },
      {
        name: "Free parking",
        icon: freeparking,
      },
    ],
  },
  //Family Room
  {
    type: "house",
    photos: [fr05, fr01, fr03, fr04, fr06, fr07, fr08],
    title: "Family Room",
    links: {
      icon: sharedlink,
      href: `${BASE_URL}/beds24/family_room`,
    },
    // mainImage: main05,
    mainImage: fr05,
    services: [
      {
        name: "Seaside view",
        icon: seaview,
      },
      {
        name: "Queen sized bed + Sofa",
        icon: kingbed,
      },
      {
        name: "Private bathroom",
        icon: privatebathroom,
      },
      {
        name: "Priavte dinning area",
        icon: privatedinning,
      },
      {
        name: "Self service breakfast",
        icon: selfbreakfast,
      },
      {
        name: "Budget friendly",
        icon: budgetfriendly,
      },
      {
        name: "Netflix TV",
        icon: tv,
      },
      {
        name: "Free Fast WiFi",
        icon: wifi,
      },
    ],
    description:
      "Our Family room is located at the Yellow House and offers an incredible view to the seaside andlighthouse. It is extremely popular for northern lights hunters in the winter. The family room is equipped with NetflixTV, a King size bed and sofa bed in seperate rooms. Bathroom, dining area and terrace are private. Kitchen facilitiesare shared. Continental self-service breakfast with homemade bread at the Blue House is included in the room rate.",
    amenities: [
      {
        name: "Queen sized bed + Sofa",
        icon: kingbed,
      },
      {
        name: "Private bathroom",
        icon: privatebathroom,
      },
      {
        name: "Private dinning area",
        icon: privatedinning,
      },
      {
        name: "Self service breakfast",
        icon: selfbreakfast,
      },
      {
        name: "Television with Netflix",
        icon: tv,
      },
      {
        name: "Bedding provided",
        icon: bedding,
      },
      {
        name: "Shared Kitchen facilities",
        icon: kitchenfacilities,
      },
      {
        name: "Self check-in anytime",
        icon: selfcheckin,
      },
      {
        name: "Free parking",
        icon: freeparking,
      },
    ],
  },
  //Two Bedroom Apartment
  {
    type: "house",
    photos: [
      tba03,
      tba01,
      tba02,
      tba04,
      tba05,
      tba06,
      tba07,
      tba08,
      tba09,
      tba10,
      tba11,
      tba12,
      tba13,
      tba14,
      tba15,
      tba16,
      tba17,
    ],
    title: "Two Bedroom Apartment",
    links: {
      icon: sharedlink,
      href: `${BASE_URL}/beds24/two_bedroom_apartment`,
    },
    // mainImage: main06,
    mainImage: tba03,
    services: [
      {
        name: "Garden view",
        icon: gardenview,
      },
      {
        name: "2 Bedrooms + 1 Sofa",
        icon: kingbed,
      },
      {
        name: "Private kitchen",
        icon: kitchen,
      },
      {
        name: "Private bathroom",
        icon: privatebathroom,
      },
      {
        name: "Cereal breakfast",
        icon: cereal,
      },
      {
        name: "Budget friendly",
        icon: budgetfriendly,
      },
      {
        name: "Netflix TV",
        icon: tv,
      },
      {
        name: "Free Fast WiFi",
        icon: wifi,
      },
    ],
    description:
      "Our two-bedroom aparment is ideal for families and groups. Located at the garden ofthe Blue House it is popular for northern lights in the winter. The Apartment offers two bedrooms with double or twinbeds and Netflix-TV. The sofabed is located in the living room and bathroom, kitchenette, terrace and dining area areprivate. Cereal Breakfast at the apartment is included in the rate. Continental self-service breakfast with homemadebread can be booked at surcharge.",
    amenities: [
      {
        name: "2 Bedrooms + 1 Sofa",
        icon: kingbed,
      },
      {
        name: "Private bathroom",
        icon: privatebathroom,
      },
      {
        name: "Cereal breakfast",
        icon: cereal,
      },
      {
        name: "Television with Netflix",
        icon: tv,
      },
      {
        name: "Bedding provided",
        icon: bedding,
      },
      {
        name: "Private Kitchenette",
        icon: kitchenfacilities,
      },
      {
        name: "Self check-in anytime",
        icon: selfcheckin,
      },
      {
        name: "Free parking",
        icon: freeparking,
      },
      {
        name: "Up to 6 People",
        icon: uptoseex,
      },
    ],
  },
  //Three Bedroom Apartment
  {
    type: "house",
    photos: [
      trba01,
      trba02,
      trba03,
      trba04,
      trba05,
      trba06,
      trba07,
      trba08,
      trba09,
    ],
    title: "Three Bedroom Apartment",
    links: {
      icon: sharedlink,
      href: `${BASE_URL}/beds24/Three_bedroom_apartment`,
    },
    // mainImage: main07,
    mainImage: trba01,
    services: [
      {
        name: "Best for 10 people",
        icon: peoples,
      },
      {
        name: "3 Bedrooms + 3 Sofa",
        icon: kingbed,
      },
      {
        name: "Private kitchen",
        icon: kitchen,
      },
      {
        name: "2 Private bathroom",
        icon: privatebathroom,
      },
      {
        name: "Cereal breakfast",
        icon: cereal,
      },
      {
        name: "Budget friendly",
        icon: budgetfriendly,
      },
      {
        name: "Netflix TV",
        icon: tv,
      },
      {
        name: "Free Fast WiFi",
        icon: wifi,
      },
    ],
    description:
      "Our largest apartment is located at the Yellow House and offers an incredible view tothe seaside and lighthouse. It is extremely popular for northern lights hunters in the winter. Up to 12 Adults (werecommend 9) can stay there and we have a variety of twin, Kingsize and sofabeds. Netflix-TV is in 3 rooms.Bathroom, kitchen, terrace and dining area are private. Cereal Breakfast at the apartment is included in the rate.Continental self-service breakfast with homemade bread can be booked at surcharge.",
    amenities: [
      {
        name: "3 Bedrooms + 3 Sofa",
        icon: kingbed,
      },
      {
        name: "2 Private bathroom",
        icon: privatebathroom,
      },
      {
        name: "Cereal breakfast",
        icon: cereal,
      },
      {
        name: "Television with Netflix",
        icon: tv,
      },
      {
        name: "Bedding provided",
        icon: bedding,
      },
      {
        name: "Private Kitchen",
        icon: kitchenfacilities,
      },
      {
        name: "Self check-in anytime",
        icon: selfcheckin,
      },
      {
        name: "Up to 12 People (10 recomended)",
        icon: peoples,
      },
      {
        name: "Free parking",
        icon: freeparking,
      },
    ],
  },
];
